<template>
  <div>
    <v-autocomplete
      ref="autocomplete"
      auto-select-first
      :hide-details="hideDetails"
      :clearable="!readonly"
      :items="options"
      v-model="innerValue"
      item-text="text"
      item-value="value"
      @blur="emitBlur"
      :solo="solo"
      :multiple="multiple"
      chips
      v-bind="resetProps"
      :disabled="disabled"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    value: [Array, String],
    solo: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
    multiple: Boolean,
    disabled: Boolean,
    readonly: Boolean
  },
  data() {
    return {
      innerValue: this.value,
    };
  },

  async created() {
    const payload = {
      PageSize: 1000,
      OrderBy: "firstName",
      Ascending: true,
    }
    await this.getAll(payload);
  },

  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      this.$emit("input", value);
      this.$emit('onSelectedObject', this.objectDetail);
      const watchObj = Array.isArray(value)
        ? this.allItems.filter((i) => value.includes(i.id))
        : this.allItems.find((i) => i.id === value)
      this.$emit("watchObject", watchObj);
    },
  },

  methods: {
    ...mapActions("user", ["getAll"]),
    emitBlur() {
      this.$emit("blur");
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
      allItems: (state) => state.user.data
    }),

    objectDetail() {
      let details = this.allItems.filter(item => item.id === this.innerValue);
      return details.length === 1 ? details[0] : {};
    },

    resetProps() {
      return { ...this.$attrs };
    },
    options() {
      return this.user.data.filter(item => item.isActive).map((user) => {
        return {
          value: user.id,
          text: `${user.firstName} ${user.lastName}`
        };
      }).sort((a, b) => (a.text.localeCompare(b.text)));
    },
  },
};
</script>